import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import Home2 from '@/views/Home2.vue';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
        },
        {
            path: '/home2',
            name: 'home',
            component: Home2,
        },
        {
            path: '/error/unauthorised',
            name: 'unauthorised',
            component: () => import(/* webpackChunkName: "err" */ './views/errors/Unauthorised.vue'),
        },
        {
            path: '/error/edl',
            name: 'edl-error',
            component: () => import(/* webpackChunkName: "err" */ './views/errors/EDLError.vue'),
        },

        {
            path: '/login',
            name: 'login-keycloak',
            component: () => import(/* webpackChunkName: "log" */ './views/logins/LoginKeycloak.vue'),
        },

        {
            path: '/inbox',
            name: 'inbox',
            component: () => import(/* webpackChunkName: "ibx" */ './views/Inbox.vue'),
        },
        {
            path: '/inbox/communication/:communicationId',
            name: 'communication',
            component: () => import(/* webpackChunkName: "ibx" */ './views/Communication.vue'),
        },

        {
            path: '/here-to-help',
            name: 'here-to-help',
            component: () => import(/* webpackChunkName: "inf" */ './views/HereToHelp.vue'),
        },

        {
            path: '/course/:courseCode/:courseName/form/session/:academicSession/type/:formType',
            name: 'form-page-new',
            component: () => import(/* webpackChunkName: "frm" */ './views/forms/FormPage.vue'),
        },
        {
            path: '/course/:courseCode/:courseName/form/session/:academicSession/type/:formType/page/:pageSlug',
            name: 'form-page-course-slug',
            component: () => import(/* webpackChunkName: "frm" */ './views/forms/FormPage.vue'),
        },
        {
            path: '/form/session/:academicSession/type/:formType/page/:pageSlug',
            name: 'form-page-slug',
            component: () => import(/* webpackChunkName: "frm" */ './views/forms/FormPage.vue'),
        },
        {
            path: '/form/session/:academicSession/type/:formType/application/:applicationID/page/:pageSlug',
            name: 'form-page-applicationid-slug',
            component: () => import(/* webpackChunkName: "frm" */ './views/forms/FormPage.vue'),
        },
        {
            path: '/form/session/:academicSession/type/:formType/application/:applicationID',
            name: 'form-page-applicationid',
            component: () => import(/* webpackChunkName: "frm" */ './views/forms/FormPage.vue'),
        },

        {
            path: '/bursary/:bursaryId',
            name: 'bursary',
            component: () => import(/* webpackChunkName: "frm" */ './views/Bursary.vue'),
        },
    ],
});
